module.exports = __webpack_public_path__ + "static/media/8-iveco-mercedes.ddd44fa4.jpg";